export default __webpack_public_path__ + "static/media/102_desktop.d9d94146.jpg";